/**
 * Grafikon form megjelenítő komponens
 * @author Koppany Kiss 2017.05.22.
 */

import moment from 'moment';
import grafikonFormTemplate from './grafikon-form.pug';
import datePicker from '../../../common/components/date-picker';
import {DATE_FORMAT_FROM_SERVER} from '../../../common/constants/consts';

const MODULE_NAME = 'grafikonForm';
const DATE_YEARS = [{year: '2010'}, {year: '2011'}];
class GrafikonFormController {
	constructor($scope) {
		'ngInject';
		this.$scope = $scope;
		this.DATE_YEARS = DATE_YEARS;

	}

	$onInit() {
		this.kezdoMinDate = '2008-01-01';
		this.zaroMaxDate = moment().format(DATE_FORMAT_FROM_SERVER);
		this.isAllPortfolioSelected = false;
		this.model = {
			portfolio: {}
		};
		this.downloadDates = {};
		this.downloadPortfolios = [];
		this.selectedPortfolioForRequest = [];
		this.$scope.$watch('$ctrl.datePickerFromIsOpen', (newValue)=>{
			if (newValue === false) {
				this.focusDatePicker('start-date-button');
			}
		});
		this.$scope.$watch('$ctrl.datePickerToIsOpen', (newValue)=>{
			if (newValue === false) {
				this.focusDatePicker('end-date-button');
			}
		});
	}

	$onChanges(changeObject) {
		if (changeObject.initData && !changeObject.initData.isFirstChange()) {
			let restInitData = angular.copy(this.initData);
			this.model.from = new Date(restInitData.startDate);
			this.model.to = new Date(restInitData.endDate);

			this.downloadDates = {
				startDate: moment(restInitData.startDate).format(DATE_FORMAT_FROM_SERVER),
				endDate: moment(restInitData.endDate).format(DATE_FORMAT_FROM_SERVER)
			};

			this.initData.portfolios.map((item) => {
				this.model.portfolio[item] = false;
			});
		}
	}

	focusDatePicker(id) {
		let elem = document.getElementById(id);
		if (elem) {
			elem.focus();
		}
	}

	postForm() {
		this.selectedPortfolioForRequest = [];
		this.hasPortfolio = false;
		// Kötelező legalább egy portfoliót választani, re-checknél modelben marad az elem csak false lesz az értéke, ezért azt is vizsgáljuk
		if (this.model.portfolio) {
			for (let portfolio in this.model.portfolio) {
				if (this.model.portfolio[portfolio]) {
					this.hasPortfolio = true;
					this.selectedPortfolioForRequest.push(portfolio);
				}
			}
		}

		if (this.form.$valid) {
			if (this.hasPortfolio) {
				let request = {
					endDate: moment(this.downloadDates.endDate).format(DATE_FORMAT_FROM_SERVER),
					portfolios: this.selectedPortfolioForRequest,
					startDate: moment(this.downloadDates.startDate).format(DATE_FORMAT_FROM_SERVER)
				};

				this.onFormSubmit({
					formModel: request
				});
			}
		}
	}

	changeFromDate(date) {
		this.downloadDates.startDate = moment(date).format(DATE_FORMAT_FROM_SERVER);
	}

	changeEndDate(date) {
		this.downloadDates.endDate = moment(date).format(DATE_FORMAT_FROM_SERVER);
	}

	changePortfolio(portfolio) {
		let index = this.downloadPortfolios.indexOf(encodeURIComponent(portfolio));
		if (index < 0) {
			this.downloadPortfolios.push(encodeURIComponent(portfolio));
		} else {
			this.downloadPortfolios.splice(index, 1);
		}
	}

	togglePortfolio() {
		if (this.model.portfolio) {
			let state = this.isAllPortfolioSelected;
			if (state) {
				this.downloadPortfolios = [];
				for (let portfolio in this.model.portfolio) {
					this.model.portfolio[portfolio] = state;
					this.downloadPortfolios.push(encodeURIComponent(portfolio));
				}
			} else {
				for (let portfolio in this.model.portfolio) {
					this.model.portfolio[portfolio] = state;
				}
				this.downloadPortfolios = [];
			}
		}
	}
}

export default angular.module(MODULE_NAME, [datePicker])
	.component('grafikonForm', {
		controller: GrafikonFormController,
		template: grafikonFormTemplate(),
		bindings: {
			initData: '<',
			onFormSubmit: '&'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/grafikon-container/grafikon-form/grafikon-form.js